import { Dialog } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

type Application = { interviews: { nodes: { id: string }[] } };

const ReadInterview = (props: { id: string; show: boolean; handleClose: () => void; application: Application }) => {
  let id = 'application_id=' + props.id;
  if (props.application.interviews && props.application.interviews.nodes[0].id) {
    id = props.application.interviews.nodes[0].id;
  }

  /* Example: works with either application_id, interview_id or both. 
  If only application_id; the first of the found interviews will be shown.
  TODO: Handle multiple interviews. 
  Base URL: 'https://hubert.ai/interview/viewer?'
  application_id: <Application oid>
  interview_id: <Interview oid>
  URL = base_url + application_id={application_id} + '&' + interview_id={interview_id}
  */
  // const baseUrl = 'http://web-hubert.ngrok.io/interview/viewer?';
  const baseUrl = 'https://interviews.hubert.ai/preview';
  const url = `${baseUrl}/${id}`;

  return (
    <Dialog.Root open={props.show} onOpenChange={props.handleClose}>
      <Dialog.Content className="readinterview">
        <Iframe url={url} />
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default ReadInterview;

const Iframe = ({ url }: { url: string }) => {
  const { t } = useTranslation();
  const iframe = `<iframe height="100%" style="width: 100%;height: 100%;" scrolling="yes" title="${t('readInterview.iframeTitle')}" src="${url}" frameborder="no" allowtransparency="true" allowfullscreen="true"/>`;
  return <div className="h-full rounded " dangerouslySetInnerHTML={{ __html: url ? iframe : '' }} />;
};
